const partOpts = {
  a: "Home Office fees",
  b: "Nation.better service fees",
};

const payableByOpts = {
  a: "Employer",
  b: "Employee",
};

const quantityOpts = {
  a: "Total",
  b: "Total per employee",
  c: "Per year / per employee",
};

const feesNew = [
  {
    part: "a",
    number: 1,
    category: "Sponsor Licence application",
    info:
      "Payable once in 4 years during the submission of an online application.",
    years: {
      1: {
        order: 1,
        option: { required: true, value: true },
        payableBy: { editable: false, value: "a" },
      },
      4: {
        order: 1,
        option: { required: true, value: true },
        payableBy: { editable: false, value: "a" },
      },
    },
    quantity: "a",
    amount: { small: 536, large: 1476 },
  },
  {
    part: "a",
    number: 2,
    category: "Certificate of Sponsorship (CoS)",
    info: [
      "New CoS should be created for each new migrant employee.",
      "This fee is the same regardless of the duration",
      "of the migrant's stay (e.g. 3 or 5 years).",
    ].join(" "),
    years: {
      1: {
        order: 2,
        option: { required: true, value: true },
        payableBy: { editable: false, value: "a" },
      },
      3: {
        order: 1,
        option: { required: true, value: true },
        payableBy: { editable: false, value: "a" },
      },
    },
    quantity: "b",
    amount: { value: 199 },
  },
  {
    part: "a",
    number: 3,
    category: "Skills Charge",
    info: [
      "It is used to address skills gaps in the UK workforce,",
      "and is due each time a CoS issued.",
      "You must not pass any of the charge on to the migrant worker.",
      "If UKVI find out that you have done this, we may revoke your licence.",
    ].join(" "),
    years: {
      1: {
        order: 3,
        option: { required: true, value: true },
        payableBy: { editable: false, value: "a" },
      },
      3: {
        order: 2,
        option: { required: true, value: true },
        payableBy: { editable: false, value: "a" },
      },
    },
    quantity: "c",
    amount: { small: 364, large: 1000 },
  },
  {
    part: "a",
    number: 4,
    category: "Immigration Health Surcharge",
    info: [
      "This fee is a surcharge levied by the Home Office",
      "for the migrant’s use of the National Health Service (‘NHS’)",
      "during their time in the UK.",
    ].join(" "),
    years: {
      1: {
        order: 4,
        option: { required: true, value: true },
        payableBy: { editable: true, value: "a" },
      },
      3: {
        order: 3,
        option: { required: true, value: true },
        payableBy: { editable: true, value: "a" },
      },
    },
    quantity: "c",
    amount: { value: 400 },
  },
  {
    part: "a",
    number: 5,
    category: "Tier 2 visa application",
    info: [
      "Payable during an online application submission process.",
      "Typically paid by a migrant employee and reimbursed by an employer later.",
    ].join(" "),
    years: {
      1: {
        order: 5,
        option: { required: true, value: true },
        payableBy: { editable: true, value: "a" },
      },
    },
    quantity: "b",
    amount: { value: 610 },
  },
  {
    part: "a",
    number: 6,
    category: "Biometric information (fingerprints and a photo) taken",
    info: [
      "An applicant will be asked to provide fingerprints and photo (‘biometric information’)",
      "as part of their visa application.",
    ].join(" "),
    years: {
      1: {
        order: 6,
        option: { required: true, value: true },
        payableBy: { editable: true, value: "a" },
      },
      3: {
        order: 5,
        option: { required: true, value: true },
        payableBy: { editable: true, value: "a" },
      },
      6: {
        order: 2,
        option: { required: true, value: true },
        payableBy: { editable: true, value: "b" },
      },
    },
    quantity: "b",
    amount: { value: 19.2 },
  },
  {
    part: "a",
    number: 7,
    category: "Tier 2 visa appointment service",
    info: [
      "Visa applicant must book an appointment to submit biometrics",
      "and supporting documents to UKVI via online system",
      "managed by a 3rd party provider Sopra Steria.",
      'The applicant can decide between "free" time slots for an appointment or "special",',
      'which require additional payment. Typically, there are limited number of "free" slots,',
      "leading for a lot of applicants to pay additional appointment service fee,",
      "and it makes it more of a required fee, rather than an optional one.",
    ].join(" "),
    years: {
      1: {
        order: 7,
        option: { required: false, value: false },
        payableBy: { editable: true, value: "a" },
      },
      3: {
        order: 6,
        option: { required: false, value: false },
        payableBy: { editable: true, value: "a" },
      },
    },
    quantity: "b",
    amount: { value: 200 },
  },
  {
    part: "a",
    number: 8,
    subnumber: 1,
    category: "Tier 2 visa priority service",
    info: "Reduces processing time from about 6 weeks to 5 working days",
    years: {
      1: {
        order: 8,
        option: { required: false, value: false },
        payableBy: { editable: true, value: "a" },
      },
      3: {
        order: 7,
        option: { required: false, value: false },
        payableBy: { editable: true, value: "a" },
      },
    },
    quantity: "b",
    amount: { value: 500 },
  },
  {
    part: "a",
    number: 8,
    subnumber: 2,
    category: "Tier 2 visa super priority service",
    info: "Reduces processing time from about 6 weeks to up to 2 days",
    years: {
      1: {
        order: 9,
        option: { required: false, value: false },
        payableBy: { editable: true, value: "a" },
      },
      3: {
        order: 8,
        option: { required: false, value: false },
        payableBy: { editable: true, value: "a" },
      },
    },
    quantity: "b",
    amount: { value: 800 },
  },
  {
    part: "b",
    number: 9,
    subnumber: 1,
    category: "Software - Sponsorship Licence application support",
    info: [
      "Self-guided service, where an application is filled in by applicants",
      "and final review is done by an expert.",
      "Nation.better won't be representing you as an advisor.",
    ].join(" "),
    years: {
      1: {
        order: 10,
        option: { required: false, value: true },
        payableBy: { editable: false, value: "a" },
      },
      4: {
        order: 2,
        option: { required: false, value: true },
        payableBy: { editable: false, value: "a" },
      },
    },
    quantity: "a",
    amount: { value: 420 },
  },
  {
    part: "b",
    number: 9,
    subnumber: 2,
    category: "Immigration advisor - Sponsorship Licence application support",
    info: [
      "Self-guided service, where an application is filled in by applicants",
      "and final review is done by an immigration advisor.",
      "Primevisa Ltd. will be representing you as an advisor.",
    ].join(" "),
    years: {
      1: {
        order: 11,
        option: { required: false, value: false },
        payableBy: { editable: false, value: "a" },
      },
      4: {
        order: 3,
        option: { required: false, value: false },
        payableBy: { editable: false, value: "a" },
      },
    },
    quantity: "a",
    amount: { value: 750 },
  },
  {
    part: "b",
    number: 10,
    subnumber: 1,
    category: "Software - Tier 2 visa application support",
    info: [
      "Self-guided service, where an application is filled in by applicants",
      "and final review is done by an expert.",
      "Nation.better won't be representing you as an advisor.",
    ].join(" "),
    years: {
      1: {
        order: 12,
        option: { required: false, value: true },
        payableBy: { editable: true, value: "a" },
      },
    },
    quantity: "b",
    amount: { value: 420 },
  },
  {
    part: "b",
    number: 10,
    subnumber: 2,
    category: "Immigration advisor - Tier 2 visa application support",
    info: [
      "Self-guided service, where an application is filled in by applicants",
      "and final review is done by an immigration advisor.",
      "Primevisa Ltd. will be representing you as an advisor.",
    ].join(" "),
    years: {
      1: {
        order: 13,
        option: { required: false, value: false },
        payableBy: { editable: true, value: "a" },
      },
    },
    quantity: "b",
    amount: { value: 750 },
  },
  {
    part: "a",
    number: 11,
    category: "Tier 2 visa extension application",
    info: "Payable during an online application submission process.",
    years: {
      3: {
        order: 4,
        option: { required: true, value: true },
        payableBy: { editable: true, value: "a" },
      },
    },
    quantity: "b",
    amount: { value: 704 },
  },
  {
    part: "b",
    number: 12,
    category: "Software - CoS creation and assignment support",
    info: [
      "Self-guided service, where an application is filled in",
      "by applicants and final review is done by an expert.",
    ].join(" "),
    years: {
      3: {
        order: 9,
        option: { required: false, value: false },
        payableBy: { editable: false, value: "a" },
      },
    },
    quantity: "b",
    amount: { value: 150 },
  },
  {
    part: "b",
    number: 13,
    subnumber: 1,
    category: "Software - Tier 2 visa extension application support",
    info: [
      "Self-guided service, where an application is filled in by applicants",
      "and final review is done by an expert.",
      "Nation.better won't be representing you as an advisor.",
    ].join(" "),
    years: {
      3: {
        order: 10,
        option: { required: false, value: true },
        payableBy: { editable: true, value: "a" },
      },
    },
    quantity: "b",
    amount: { value: 420 },
  },
  {
    part: "b",
    number: 13,
    subnumber: 2,
    category: "Immigration advisor - Tier 2 visa extension application support",
    info: [
      "Self-guided service, where an application is filled in by applicants",
      "and final review is done by an immigration advisor.",
      "Primevisa Ltd. will be representing you as an advisor.",
    ].join(" "),
    years: {
      3: {
        order: 11,
        option: { required: false, value: false },
        payableBy: { editable: true, value: "a" },
      },
    },
    quantity: "b",
    amount: { value: 750 },
  },
  {
    part: "a",
    number: 14,
    category: "Settlement / ILR application",
    info: "Payable during an online application submission process.",
    years: {
      6: {
        order: 1,
        option: { required: true, value: true },
        payableBy: { editable: true, value: "b" },
      },
    },
    quantity: "b",
    amount: { value: 2389 },
  },
  {
    part: "a",
    number: 15,
    category: "Settlement / ILR appointment service",
    info: [
      "Visa applicant must book an appointment to submit biometrics",
      "and supporting documents to UKVI via online system managed by a 3rd party provider Sopra Steria.",
      'The applicant can decide between "free" time slots for an appointment',
      'or "special", which require additional payment.',
      'Typically, there are limited number of "free" slots, leading',
      "for a lot of applicants to pay additional appointment service fee,",
      "and it makes it more of a required fee, rather than an optional one.",
    ].join(" "),
    years: {
      6: {
        order: 3,
        option: { required: false, value: false },
        payableBy: { editable: true, value: "b" },
      },
    },
    quantity: "b",
    amount: { value: 200 },
  },
  {
    part: "a",
    number: 16,
    subnumber: 1,
    category: "Settlement / ILR priority service",
    info: "Reduces processing time from about 6 weeks to 5 working days",
    years: {
      6: {
        order: 4,
        option: { required: false, value: false },
        payableBy: { editable: true, value: "b" },
      },
    },
    quantity: "b",
    amount: { value: 500 },
  },
  {
    part: "a",
    number: 16,
    subnumber: 2,
    category: "Settlement / ILR super priority service",
    info: "Reduces processing time from about 6 weeks to up to 2 days",
    years: {
      6: {
        order: 5,
        option: { required: false, value: false },
        payableBy: { editable: true, value: "b" },
      },
    },
    quantity: "b",
    amount: { value: 800 },
  },
  {
    part: "b",
    number: 17,
    subnumber: 1,
    category: "Software - Settlement / ILR application support",
    info: [
      "Self-guided service, where an application is filled in by applicants",
      "and final review is done by an expert.",
      "Nation.better won't be representing you as an advisor.",
    ].join(" "),
    years: {
      6: {
        order: 6,
        option: { required: false, value: false },
        payableBy: { editable: true, value: "b" },
      },
    },
    quantity: "b",
    amount: { value: 150 },
  },
  {
    part: "b",
    number: 17,
    subnumber: 2,
    category: "Immigration advisor - Settlement / ILR application support",
    info: [
      "Self-guided service, where an application is filled in by applicants",
      "and final review is done by an immigration advisor.",
      "Primevisa Ltd. will be representing you as an advisor.",
    ].join(" "),
    years: {
      6: {
        order: 7,
        option: { required: false, value: false },
        payableBy: { editable: true, value: "b" },
      },
    },
    quantity: "b",
    amount: { value: 500 },
  },
];

export { partOpts, quantityOpts, payableByOpts };
export default feesNew;
